import { readContract, } from "wagmi/actions";
import moment from "moment";
import { wagmiConfig, } from "@config";

import type { ChainId, TokenDefinition, } from "@bracket/addressbook";

import * as contracts from "../../../contracts";

import type { Address, } from "@types";


export declare type GetTokenInfoResult = {
	whitelisted: boolean;
	rebase: Address;
	totalStaked: bigint;
}

export const isGetTokenInfoResult = ( value: unknown ): value is GetTokenInfoResult => {
	if( typeof value === "object" && !Array.isArray(value) && value !== null ) {
		if( ['whitelisted', 'rebase', 'totalStaked'].every(key => Object.keys(value).includes(key)) ) {
			return true;
		}
	}
	return false;
}

export const getTokenInfo = async ({
	chain,
	token,
	attempt = 0,
	force = false,
}: {
	chain: ChainId;
	token: TokenDefinition;
	attempt?: number;
	force?: boolean;
}): Promise<GetTokenInfoResult> => {

	try {

		const now = moment().unix();
		const cache = getTokenCache(chain);
		const cached = cache.get(token.symbol);

		if(!force) {
			if(cached) {
				const { since, value, } = cached;
				if(now - since < cachedTokenInfoTTL) {
					return value;
				}
			}
		}

		const result = await readContract(wagmiConfig, contracts.Escrow.getTokenInfo({chain, token, }));

		if(isGetTokenInfoResult(result)) {
			cache.set(token.symbol, { since: now, value: result, });
			return result;
		}

		throw new Error(`token info for "${token.symbol}" on chain ${chain} returned malformed`);
	}
	catch(err) {
		if(attempt < 3) {
			return getTokenInfo({ chain, token, });
		}
		throw new Error(`EscrowStore::getTokenInfo failed after ${attempt} attempts to get info for token "${token.symbol}" on chain ${chain}`);
	}

}

const getTokenCache = ( chain: ChainId, ): Map<string, { value: GetTokenInfoResult, since: number}> => {
	let cache = cachedTokenInfo.get(chain);
	if(!cache) {
		cachedTokenInfo.set(chain, new Map());
		cache = cachedTokenInfo.get(chain);
	}
	if(cache) {
		return cache;
	}
	throw new Error("EscrowStore::getTokenCache failed to produce a valid cache");
}

const cachedTokenInfoTTL = 3600; // 1 hour.
const cachedTokenInfo = new Map<ChainId, Map<string, { value: GetTokenInfoResult, since: number}>>();
